import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import axios from "axios";
import VueAxios from "vue-axios";

import "font-awesome/css/font-awesome.min.css";

import VButton from "@/components/elements/VButton.vue";
import VCheckBox from "@/components/elements/VCheckBox.vue";
import VInput from "@/components/elements/VInput.vue";

require("@/assets/css/style.scss");

Vue.component("VButton", VButton);
Vue.component("VCheckBox", VCheckBox);
Vue.component("VInput", VInput);

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401) {
      store.commit("logout");
    }
    return Promise.reject(error);
  }
);

Vue.use(VueAxios, axios);

Vue.prototype.$API = process.env.VUE_APP_API_URL;

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    if (store.getters.token) {
      this.axios.defaults.headers.common = {
        Authorization: `Bearer ${store.getters.token}`
      };
    }
  }
}).$mount("#app");
